var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.377 5.992 9 11.472l5.623-5.48a.538.538 0 0 1 .865.167.51.51 0 0 1-.114.564l-5.981 5.832a.56.56 0 0 1-.786 0l-5.981-5.83a.51.51 0 0 1 0-.734.54.54 0 0 1 .751 0"
  })));
};
export default SvgArrowDown;